import React, { useMemo, useState } from 'react'

import { Dropdown } from '@/components'
import { useTicketFiltersContext } from '@/context/filters/ticketFilters/ticketFilters'
import { TicketReasonsQueries } from '@/graphql/queries/ticketReasons.queries'
import { useGraphql } from '@/hooks/useGraphql'
import { TicketReason } from '@/types/TicketReason'

import { FilterOptionsStyled } from './PriorityFilter'

export const ReasonFilter = () => {
  const { setFilters, ticketReasons, ticketTypes } = useTicketFiltersContext()
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const { data: reasonsData, isLoading } = useGraphql<{ ticketReasons: TicketReason[] }>(
    TicketReasonsQueries.QUERY_KEY,
    TicketReasonsQueries.getTicketReasons(),
  )
  const selectedTicketTypes = ticketTypes && ticketTypes.length ? ticketTypes : null
  const ticketReasonOptions = useMemo(() => {
    if (isLoading || !reasonsData?.ticketReasons || !selectedTicketTypes) {
      return []
    }

    // Get unique reasons across all selected types
    const reasonsMap = new Map<string, { label: string; val: string }>()
    reasonsData.ticketReasons
      .filter((t) => selectedTicketTypes.includes(t.ticketType))
      .forEach((t) => {
        if (!reasonsMap.has(t.description)) {
          reasonsMap.set(t.description, {
            val: t.description,
            label: t.description,
          })
        }
      })

    return Array.from(reasonsMap.values()).sort((a, b) => a.label.localeCompare(b.label))
  }, [reasonsData?.ticketReasons, isLoading, selectedTicketTypes])
  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: string | null = null) => {
    setDropdownExpanded(false)
    setFilters({ ticketReasons: val ? [val] : null })
  }

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Reason"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!ticketReasons}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          <li className={`${!ticketReasons ? 'selected' : ''}`} onClick={() => changeFilter()} role={'presentation'}>
            All
          </li>
          {ticketReasonOptions.map(({ val, label }, i) => (
            <li
              className={`${ticketReasons && ticketReasons[0] === val ? 'selected' : ''} capitalize`}
              key={i}
              onClick={() => changeFilter(val)}
              role={'presentation'}
            >
              {label}
            </li>
          ))}
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
